import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const rows = [
  { product: 'Patrocinio Gold Punto de Fe', detail: 'Menciones, rotativa audiovisual y presencia de marca en set con Margarita', investment: '$200' },
  { product: 'Segmento "Trazos de Esperanza"', detail: 'Espacio editorial de marca con demostración de uso de productos premium', investment: '$125' },
  { product: 'Estrategia TNO Digest', detail: 'Artículos de autoridad que vinculan a Artesco con bienestar y salud mental', investment: '$100' },
  { product: 'Campaña Multiplataforma', detail: 'Producción de Reels de alta gama y presencia en formato On-Demand', investment: '$75' },
];

const InvestmentSummary = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Resumen
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Arquitectura de Inversión (Aliado de Bienestar)
        </Box>
      </Box>
      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 720, mx: 'auto', borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Concepto de Servicio</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Impacto Estratégico</TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 700 }}>
                Inversión
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.product}</TableCell>
                <TableCell>{row.detail}</TableCell>
                <TableCell align="right">{row.investment}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.primary.light }}>
              <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
                INVERSIÓN MENSUAL TOTAL
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>
                $500
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ maxWidth: 720, mx: 'auto', mt: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          Posicionamiento 360° con propósito y alta fidelidad. © TNO Network 2026 | The Content Evolution.
        </Typography>
      </Box>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InvestmentSummary;
